module.exports = "fragment AmountFragment on Amount {\n  __typename\n  amount\n  currency\n  description\n}\n"